import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["drawer"]

  connect () {
    document.getElementById("notif-trigger")?.addEventListener("click", e => {
      e.preventDefault()
      this.toggle()
    })
  }

  toggle () {
    const drawer = this.drawerTarget
    const backdrop = document.getElementById("notif-backdrop")
    const open = drawer.classList.contains("d-none")
    drawer.classList.toggle("d-none", !open)
    backdrop.classList.toggle("d-none", !open)
  }

  close () {
    this.drawerTarget.classList.add("d-none")
    document.getElementById("notif-backdrop").classList.add("d-none")
  }
} 